export default "__VITE_PUBLIC_ASSET__f0359049__"